import React from "react";
import Stripe from "../Stripe";
import Popup from "../Popup";
import { useDispatch } from "react-redux";
import { setPaymentModal } from "../../Store/Slice/techsbookSlice";

export default function PaymentModal() {
  const dispatch = useDispatch();
  const closeInfo = () => {
    dispatch(setPaymentModal(false));
  };
  return (
    <Popup closePopup={closeInfo} title="Add new card">
      <Stripe />
    </Popup>
  );
}
